import { NavigateBackLink } from '@exam-management/components';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { AddQBankStructureToQConfigGeneratorProvider } from '@exam-management/qconfig-generator-creation';
import { useParams } from '@exam-management/router';
import { PageHeader } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';
import { Outlet } from 'react-router-dom';

export default function QConfigGeneratorsLayout() {
  const { courseId } = useParams('/exam-courses/:courseId/qconfig-generators/create');
  return (
    <PermissionGuard
      requiredPermission={[
        APP_PERMISSIONS.EXAM.QCONFIG.CREATE,
        APP_PERMISSIONS.QBANK.STRUCTURE.VIEW,
      ]}
    >
      <PageHeader
        title='Generate QConfig'
        linkAdornment={
          <NavigateBackLink
            to='/exam-courses/:courseId/qconfig-generators'
            params={{ courseId }}
            label='Back'
          />
        }
      />
      <AddQBankStructureToQConfigGeneratorProvider>
        <Outlet />
      </AddQBankStructureToQConfigGeneratorProvider>
    </PermissionGuard>
  );
}
